'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Badge = require('./Badge');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Badge).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/Badge/index.js
// module id = 1408
// module chunks = 35783957827783